import { StyleSheet } from '@react-pdf/renderer';

export const HOUR_NUMBER_WIDTH = 25;
export const LINE_MARGIN_LEFT = 20;
export const CANDLE_PADDING_LEFT = 17;
export const CANDLE_WIDTH = 4;
export const CANDLE_GAP = 11;
export const ROW_HEIGHT = 27;

export const diagramStyle = StyleSheet.create({
    diagram: {
        flexDirection: 'column',
        width: '100%',
        rowGap: 16,
        position: 'relative',
        marginTop: 24,
    },
    hours: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    hour: {
        width: HOUR_NUMBER_WIDTH,
        fontSize: 10,
        fontWeight: 400,
        textAlign: 'center',
        color: '#455166',
    },
    line: {
        marginLeft: LINE_MARGIN_LEFT,
        borderBottom: '1px dashed #C5E0FF',
        width: '100%',
    },
});
